import { styled, Typography } from '@mui/material';
import { ReactComponent as Check } from '@/assets/images/check.svg';

const Main = styled('button')<{ active: boolean }>(({ theme, active }) => {
  const borderColor = theme.palette.border.contrastText;

  return {
    paddingInline: 20,
    paddingBlock: 16,
    borderRadius: 16,
    borderWidth: 1,
    outlineWidth: 1,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    outlineStyle: 'solid',
    borderStyle: 'solid',
    background: 'transparent',
    transition: 'border-color 0.2s ease, outline-color 0.2s ease',
    borderColor: active ? borderColor : theme.palette.border.main,
    outlineColor: active ? borderColor : 'transparent',

    '@media (any-hover: hover)': {
      '&:hover': {
        borderColor: borderColor,
        outlineColor: borderColor,
      },
    },
  };
});

type Props = {
  disabled: boolean;
  name: string;
  active: boolean;
  onClick: () => void;
};

export default function Option({ disabled, name, active, onClick }: Props) {
  return (
    <Main onClick={onClick} disabled={disabled} active={active}>
      <Typography fontSize={20} fontWeight={700} color="black">
        {name}
      </Typography>
      {active && <Check />}
    </Main>
  );
}
